import { Suspense, useState, useEffect } from "react"
import styled from "styled-components"
import { Canvas } from "@react-three/fiber"
import { VIEW_INDEX } from "@data/viewIndex"

import CameraControls from "./components/CameraControls"
import Sphere from "./components/Sphere"

type TProps =
  | {
      texture: string
      textureCallback?: () => void
      camera?: any
      hasLimit?: undefined | false
      initialPosition?: any
      unit: any
    }
  | {
      texture: string
      unit: any
      textureCallback?: () => void
      camera?: any
      hasLimit?: true
      initialPosition?: any
      maxHor: number
      minHor: number
      maxVer: number
      minVer: number
      hotspots: any[]
      onHotspotClick: (index: number) => void
    }

const floormap = {
  "6": [1, 2],
  "12": [3, 4],
  "18": [5, 6],
  "24": [7, 8],
  "30": [9, 10],
  "36": [11, 12],
  "42": [13, 14, 15],
  "54": [16, 17, 18],
  "60": [19, 20],
  "66": [21, 22],
  "72": [23, 24],
}

const rotations = {
  C1: 0,
  C2: Math.PI * 0.5,
  C3: Math.PI,
  C4: Math.PI * 1.5,
}

function SphericalTour(props: TProps) {
  const unit = props.unit[0]
  const viewID = VIEW_INDEX[unit.unitName]
  const initialRotation = rotations[viewID[0]]
  const floor = Object.entries(floormap).find(([_, floors]) =>
    floors.includes(unit.floor),
  )?.[0]

  const renamed = viewID[0].replace("C", "386_Panorama_Corner")

  const [fileExists, setFileExists] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>("")
  console.log(floor)

  // useEffect(() => {
  //   const checkFileExists = async () => {
  //     try {
  //       const response = await fetch(src, { method: "HEAD" })
  //       setFileExists(response.ok)
  //     } catch (error) {
  //       setErrorMessage(error?.toString() || "Unknown error occurred")
  //       setFileExists(false)
  //     }
  //   }

  //   checkFileExists()
  // }, [src])

  // if (!fileExists) {
  //   return <div>{`360° view not available: ${errorMessage}`}</div>
  // }

  return (
    <Scene camera={{ ...props.camera, fov: 80 }}>
      <Suspense>
        <>
          <CameraControls />
          <Sphere
            renamed={renamed}
            floor={floor}
            callback={props.textureCallback}
            initialPosition={[0, initialRotation, 0]}
          />
        </>
      </Suspense>
    </Scene>
  )
}

export default SphericalTour

const Scene = styled(Canvas)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
`
